// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"4ebd3573","197":"3cca6a3c","341":"75372a22","437":"d63257a1","741":"232ce51b","800":"8653a11e","950":"2096b554"}[chunkId] + ".chunk.js";
};